/**
 * Code copied from https://stackoverflow.com/a/16245768
 */
export default (b64Data, sliceSize = 512) => {
    const regex = /^data:(.+);base64,/g
    const matches = b64Data.match(regex)

    let contentType = 'application/pdf'

    if (matches && matches.length > 1) {
        contentType = matches[1]
    }

    const byteCharacters = atob(b64Data.replace(regex, ''))
    const byteArrays = []

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize)
        const byteNumbers = new Array(slice.length)

        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i)
        }

        const byteArray = new Uint8Array(byteNumbers)

        byteArrays.push(byteArray)
    }

    const blob = new Blob(byteArrays, {
        type: contentType
    })

    return {
        blob,
        url: URL.createObjectURL(blob)
    }
}